import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../sdk/service/alert.service';
import {AuthenticationService} from '../../sdk/service/authentication.service';
import {PublicSubmitForm} from '../../sdk/interface/form/public-submit-form';
import {ROUTES} from '../../app.routes';
import {PublicService, UserCreate} from 'web-angular-client';
import {SyncValidators} from '../../sdk/validator/SyncValidators';
import {EnvironmentService} from '../../sdk/service/environment.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {finalize} from 'rxjs';
import {CARD_SIZE} from '../../sdk/component/public-page-template/public-page-template.component';

@Component({
    selector: 'app-register-user',
    templateUrl: './register-anonymous-user.component.html',
    styleUrls: ['./register-anonymous-user.component.scss'],
    standalone: false
})
export class RegisterAnonymousUserComponent extends PublicSubmitForm implements OnInit
{
    loading: boolean;
    tokenId: string;
    protected readonly CARDSIZE = CARD_SIZE;

    constructor(
        protected router: Router,
        protected formBuilder: UntypedFormBuilder,
        protected alertService: AlertService,
        protected route: ActivatedRoute,
        protected authenticationService: AuthenticationService,
        protected publicService: PublicService,
        private ngxLoader: NgxUiLoaderService,
        protected environmentService: EnvironmentService,
    )
    {
        super(router, formBuilder, alertService, authenticationService, environmentService);
    }

    ngOnInit()
    {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            surname: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            mobileNumber: ['', SyncValidators.validateMobileNumber()],
            password: ['', [Validators.required, SyncValidators.validatePassword]],
            confirmPassword: ['', Validators.required]
        }, {validator: SyncValidators.validatePasswordMatch});

        this.loading = true;
        this.route.queryParams.subscribe((params) =>
        {
            this.tokenId = params.tokenId;

            if (this.tokenId == null || '' === this.tokenId.trim())
            {
                this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then();
            }

            this.ngxLoader.start();
            this.publicService.processUserInvitationTokenId(params.tokenId)
                .pipe(finalize(() => this.ngxLoader.stop()))
                .subscribe({
                    next: (userInvitation) =>
                    {
                        this.loading = false;

                        if (null === userInvitation)
                        {
                            this.alertService.success(
                                'Invitation Accepted Successfully, Login to view the list of your businesses',
                                true);
                            this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then();
                        }
                        else
                        {
                            this.f.email.setValue(userInvitation.email);
                            this.f.mobileNumber.setValue(userInvitation.mobileNumber);
                        }

                    }, error: (error) =>
                    {
                        this.loading = false;
                        this.alertService.error(error, true);
                        this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then();
                    }
                });
        });
    }

    submit()
    {
        this.publicService.createUserWithTokenId(this.getUserCreateFromForm()).subscribe(
            {
                next:
                    () =>
                    {
                        // the user was registered, now we want to authenticate the user
                        this.authenticationService.login(this.f.email.value, this.f.password.value).subscribe(
                            {
                                next:
                                    () =>
                                    {
                                        this.loading = false;
                                        // successfully authenticated.
                                        this.debugOutput('registration successful');
                                        this.alertService.success(
                                            'User ' + this.f.email.value + ' successfully registered',
                                            true);
                                        this.router.navigate([this.routes.SECURE.HOME.VIEW.path]).then();
                                    },
                                error: (error) =>
                                {
                                    this.loading = false;
                                    // new user could not be authenticated, this should not normally happen.
                                    this.debugOutput('registration unsuccessful' + error.error.message);
                                    this.alertService.error('Registered user authentication failed', true);
                                    this.router.navigate([this.routes.PUBLIC.LOGIN.path]).then();
                                }
                            });
                    }, error:
                    error =>
                    {
                        this.loading = false;
                        // user registration failed. This can be due to an exception.
                        console.error('user registration error ' + error.error.message);
                        this.alertService.error(
                            'We weren\'t able to register your account. Please try again or contact support for help.',
                            true);
                        this.router.navigate([this.routes.PUBLIC.LOGIN.path]).then();
                    }
            });
    }

    private getUserCreateFromForm(): UserCreate
    {
        let userCreate: UserCreate = {};
        userCreate.user = {
            email: this.f.email.value,
            name: this.f.name.value,
            surname: this.f.surname.value,
            mobileNumber: this.f.mobileNumber.value
        };
        userCreate.password = this.f.password.value;
        userCreate.tokenId = this.tokenId;

        return userCreate;
    }
}